// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3ILKw","footer":"ModalCreateQualiphyProcedure_footer__1BgrF","additionData":"ModalCreateQualiphyProcedure_additionData__3cn5u"};